import * as React from 'react';
import VarietiesTable from '../VarietiesTable';

export default function MatchVarietiesTab(props: { matchId: number; matchState: number }) {
    return <VarietiesTable matchId={props.matchId} matchState={props.matchState} />;
}
